import {SETMESSAGECOUNT} from '../constact'
const messageCount = data => ({
    type: SETMESSAGECOUNT,
    data
})
export default messageCount;